<script>
import core from '@/core';

export default {
  name: 'UlFormTouristFio',
  props: {
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    elInput() {
      return this.$refs.input;
    },
  },
  methods: {
    input(value) {
      this.$emit('input', value);
    },
    change(value) {
      this.$emit('change', value);
    },
    querySearch(query = '', cb) {
      if (query.length < 3) {
        cb([]);
        return;
      }
      core.api.tourist
        .list({
          name: query,
          requestId: 'ui-form-tourist-fio',
        })
        .then((data) => {
          cb(data.Items.map(i => ({
            ...i,
            value: i.ID,
            label: `${i.Name || ''} ${i.FirstName || ''} ${i.MiddleName || ''}`,
            passportRu: (`${i.PassportRusSer || ''} ${i.PassportRusNumber || ''} ${(i.PassportRusDate?.Serialized ? ` от ${i.PassportRusDate?.Serialized}` : '')}`).trim(),
            passportEn: (`${i.PassportType || ''} ${i.PassportNumber || ''}${(i.PassportDate?.Serialized ? ` от ${i.PassportDate?.Serialized}` : '')}${(i.PassportDateEnd?.Serialized ? ` до ${i.PassportDateEnd?.Serialized}` : '')}`).trim(),
            birthday: i.Birthday?.Serialized || '',
            phone: i.Phone || '',
            email: i.Email || '',
          })));
        }, () => {
          cb([]);
        });
    },
    select(item) {
      this.$emit('select', item);
    },
  },
};
</script>
<template>
  <el-autocomplete
    ref="input"
    :type="type"
    class="ul-form-tourist-fio"
    :value="value"
    :fetch-suggestions="querySearch"
    :trigger-on-focus="false"
    :placeholder="placeholder"
    :disabled="disabled"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @input="input"
    @change="change"
    @select="select"
    popper-class="ul-form-tourist-fio__popper"
  >
    <div slot-scope="{item}" style="line-height: 18px; padding: 8px 0;">
      <div>
        <span style="font-weight: 700">
          {{ item.label }} {{ item.Gender }}
        </span>
        <span
          style="float: right; color: #8492a6; font-size: 13px"
        >
          {{item.birthday}}
        </span>
      </div>
      <div v-if="item.phone">
        <span><b>Телефон:</b> +{{item.phone}}</span>
      </div>
      <div v-if="item.email">
        <span><b>Email:</b> {{item.email}} </span>
      </div>
      <div v-if="item.passportRu">
        <span><b>Паспорт:</b> {{item.passportRu}} </span>
      </div>
      <div v-if="item.passportEn">
        <span><b>Загранпаспорт:</b> {{item.passportEn}} </span>
      </div>
    </div>
  </el-autocomplete>
</template>
<style lang="scss">
  .ul-form-tourist-fio {
    &__popper {
      width: 450px !important;
    }

    .el-input__inner {
      border: none !important;
      font-size: 16px;
      width: 100%;
      outline: none;
      background: none !important;
      position: relative;
      height: 28px;
      display: block;
      padding: 0;
      color: #333333;

      &::placeholder {
        font-weight: 300;
        color: #666;
      }
    }

    .el-input.is-disabled .el-input__inner {
      cursor: default;
    }
  }
</style>
